import { Typography, Chip, Box, Tooltip } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

export const changeOrderColumns = ({ previousRevNumber, currentRevNumber }) => [
  {
    accessorKey: "tagNumbers",
    header: "Tag #",
    enableEditing: false,
    grow: false, //don't allow this column to grow to fill in remaining space
    size: 140,
    Cell: ({ row }) => {
      const m = row.original;
      const state = row.original.state;

      const getStateIcon = () => {
        switch (state) {
          case "new":
            return (
              <Tooltip title="New material in current revision">
                <AddCircleIcon sx={{ color: "success.main", fontSize: 18 }} />
              </Tooltip>
            );
          case "deleted":
            return (
              <Tooltip title="Deleted from current revision">
                <DeleteIcon sx={{ color: "error.main", fontSize: 18 }} />
              </Tooltip>
            );
          case "updated":
            return (
              <Tooltip title="Changed from previous revision">
                <EditIcon sx={{ color: "warning.main", fontSize: 18 }} />
              </Tooltip>
            );
          default:
            return null;
        }
      };

      return (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <Typography sx={{ flex: 1 }}>
            {m?.taggedMaterial?.tagNumber}
          </Typography>
          {getStateIcon()}
        </Box>
      );
    },
  },
  {
    header: "Previous Revision (Rev-" + previousRevNumber + ")",
    accessorKey: "ppp",

    columns: [
      {
        header: "Description",
        accessorKey: "previousDescription",
        enableEditing: false,
        size: 250,
        Cell: ({ row }) => {
          const state = row.original.state;
          return (
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <Typography sx={{ flex: 1 }}>
                {row.original.previousDescription}
              </Typography>
              {state === "deleted" && (
                <Tooltip title="Deleted from current revision">
                  <DeleteIcon sx={{ color: "error.main", fontSize: 18 }} />
                </Tooltip>
              )}
            </Box>
          );
        },
      },

      {
        header: "Quantity",
        accessorKey: "previousQuantity",
        enableEditing: false,
        size: 10,
      },
      {
        header: "Unit",
        accessorKey: "unit",
        enableEditing: false,
        size: 20,
        Cell: ({ row }) => (row.original.previousDescription ? "Nos" : ""),
      },
      {
        header: "Previous MRQ",
        accessorKey: "previousMrq",
        enableEditing: false,
        size: 150,
      },
    ],
  },
  {
    header: "Selected Revision (Rev-" + currentRevNumber + ")",
    accessorKey: "sss",
    columns: [
      {
        header: "Description",
        accessorKey: "selectedDescription",
        enableEditing: false,
        size: 250,
        Cell: ({ row }) => {
          const state = row.original.state;

          const getStateConfig = () => {
            switch (state) {
              case "new":
                return {
                  label: "New",
                  color: "success",
                  icon: <AddCircleIcon />,
                  tooltip: "New material in current revision",
                };
              case "deleted":
                return {
                  label: "Deleted",
                  color: "error",
                  icon: <DeleteIcon />,
                  tooltip: "Removed from current revision",
                };
              case "updated":
                return {
                  label: "Updated",
                  color: "warning",
                  icon: <EditIcon />,
                  tooltip: "Changed from previous revision",
                };
              default:
                return null;
            }
          };

          const config = getStateConfig();

          return (
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <Typography sx={{ flex: 1 }}>
                {row.original.selectedDescription}
              </Typography>
              {config && (
                <Tooltip title={config.tooltip}>
                  <Chip
                    label={config.label}
                    size="small"
                    color={config.color}
                    variant="outlined"
                    icon={config.icon}
                  />
                </Tooltip>
              )}
            </Box>
          );
        },
      },
      {
        header: "Quantity",
        accessorKey: "selectedQuantity",
        enableEditing: false,
        size: 10,
      },
      {
        header: "Unit",
        accessorKey: "unit",
        enableEditing: false,
        size: 20,
        Cell: ({ row }) => (row.original.selectedDescription ? "Nos" : ""),
      },
      {
        header: "Selected MRQ",
        accessorKey: "selectedMrq",
        enableEditing: false,
        size: 150,
      },
    ],
  },
];
